import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './common/LanguageSwitcher';
import './ResourcesPage.css';

const ResourcesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('landing');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const educationalLevels = {
    primary: {
      nameKey: 'resources.primarySchool',
      years: ['Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5'],
      icon: 'child_care',
      path: '/resources/primary'
    },
    middle: {
      nameKey: 'resources.middleSchool',
      years: ['1AM', '2AM', '3AM', '4AM', 'BEM'],
      icon: 'school',
      path: '/resources/middle'
    },
    high: {
      nameKey: 'resources.highSchool',
      years: ['1AS', '2AS', 'BAC'],
      icon: 'menu_book',
      path: '/resources/high'
    }
  };

  const handleLevelClick = (levelKey) => {
    navigate(educationalLevels[levelKey].path);
  };

  return (
    <div className="resources-page">
      {/* Navigation Bar */}
      <nav className={`landing-navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="logo" onClick={() => navigate('/')}>
            <span className="material-icons">school</span>
            <span>Syllera</span>
          </div>
          <div className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); setIsMobileMenuOpen(false); }}>{t('nav.features')}</a>
            <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); setIsMobileMenuOpen(false); }}>{t('nav.howItWorks')}</a>
            <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); setIsMobileMenuOpen(false); }}>{t('nav.pricing')}</a>
            <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); setIsMobileMenuOpen(false); }}>{t('nav.reviews')}</a>
            <a href="/resources" onClick={(e) => { e.preventDefault(); navigate('/resources'); setIsMobileMenuOpen(false); }} className="active">{t('nav.resources')}</a>
            <a href="/business" onClick={(e) => { e.preventDefault(); navigate('/business'); setIsMobileMenuOpen(false); }}>{t('nav.business')}</a>
          </div>
          <div className="nav-actions">
            <LanguageSwitcher className="landing-language-switcher" />
            <button className="btn-login" onClick={() => scrollToSection('login')}>{t('nav.login')}</button>
            <button className="btn-primary" onClick={() => navigate('/signup')}>{t('nav.startLearning')}</button>
            <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
              <span className="material-icons">{isMobileMenuOpen ? 'close' : 'menu'}</span>
            </button>
          </div>
        </div>
      </nav>

      <div className="resources-container" style={{ paddingTop: '80px' }}>
        {/* Header */}
        <div className="resources-header">
          <h1 className="resources-title">
            <span className="material-icons">folder_special</span>
            {t('resources.title')}
          </h1>
          <p className="resources-subtitle">
            {t('resources.subtitle')}
          </p>
        </div>

        {/* Level Selection */}
        <div className="levels-grid">
          {Object.entries(educationalLevels).map(([key, level]) => (
            <div
              key={key}
              className="level-card"
              onClick={() => handleLevelClick(key)}
            >
              <span className="material-icons level-icon">{level.icon}</span>
              <h3>{t(level.nameKey)}</h3>
              <p>{t('resources.levelsAvailable', { count: level.years.length })}</p>
            </div>
          ))}
        </div>

        {/* Info Banner */}
        <div className="info-banner">
          <span className="material-icons">info</span>
          <div>
            <strong>{t('resources.freeAccess')}</strong> {t('resources.freeAccessDesc')}
            <br />
            <strong>{t('resources.loginRequired')}</strong> {t('resources.loginRequiredDesc')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;
